import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SELECT_CARD } from '@symphony-solo/shared/utils/src';
import { tap } from 'rxjs/operators';
import { selectPaymentAction } from './payments.actions';

@Injectable()
export class PaymentsEffects {
  constructor(private actions$: Actions, private navController: NavController) {}

  protected selectPayment$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(selectPaymentAction),
        tap(() => {
          this.navController.navigateForward(SELECT_CARD);
        })
      );
    },
    { dispatch: false }
  );
}
